var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34717 12.3711C1.31885 12.3711 0.69043 11.6411 0.69043 10.7144C0.69043 10.4351 0.766602 10.1431 0.925293 9.86377L5.57812 1.75146C5.89551 1.20557 6.44141 0.919922 7 0.919922C7.55859 0.919922 8.10449 1.19922 8.42188 1.75146L13.0747 9.86377C13.2271 10.1367 13.3096 10.4351 13.3096 10.7144C13.3096 11.6411 12.6812 12.3711 11.6528 12.3711H2.34717ZM2.3916 11.3618H11.6084C12.0083 11.3618 12.2622 11.0444 12.2622 10.6953C12.2622 10.5811 12.2368 10.4541 12.167 10.3271L7.55225 2.26562C7.43164 2.0498 7.21582 1.95459 7 1.95459C6.78418 1.95459 6.56201 2.0498 6.44141 2.26562L1.82666 10.3208C1.76318 10.4478 1.73779 10.5811 1.73779 10.6953C1.73779 11.0444 1.98535 11.3618 2.3916 11.3618ZM7 8.2832C6.68896 8.2832 6.51758 8.10547 6.51123 7.78809L6.42871 4.69678C6.41602 4.37939 6.65723 4.14453 6.99365 4.14453C7.33008 4.14453 7.57764 4.38574 7.57129 4.70312L7.48242 7.78809C7.47607 8.11182 7.29834 8.2832 7 8.2832ZM7 10.2446C6.64453 10.2446 6.3335 9.96533 6.3335 9.60986C6.3335 9.25439 6.63818 8.9751 7 8.9751C7.36816 8.9751 7.6665 9.25439 7.6665 9.60986C7.6665 9.97168 7.36182 10.2446 7 10.2446Z",
    fill: "#FF9F0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTriangle);
export default __webpack_public_path__ + "static/media/orangeTriangle.c53b8becbd53b06aaba12a9dcd3d0a75.svg";
export { ForwardRef as ReactComponent };